import { Controller } from "@hotwired/stimulus";

// Frame N: two passes on one screen — choose, then confirm; the fourth
// digit advances each pass (no Continue button). Server re-validates
// everything; this controller only stages the two entries.
export default class extends Controller {
  static targets = ["form", "pin", "confirmation", "sub", "notice"];
  static outlets = ["pin-pad"];
  static values = { confirmPrompt: String, initialPrompt: String };

  connect() {
    this.stage = 1;
  }

  filled(event) {
    if (this.hasNoticeTarget) this.noticeTarget.classList.add("hidden");
    if (this.stage === 1) {
      if (this.hasPinTarget) this.pinTarget.value = event.detail.pin;
      this.stage = 2;
      if (this.hasSubTarget) this.subTarget.textContent = this.confirmPromptValue;
      if (this.hasPinPadOutlet) this.pinPadOutlet.clear();
    } else {
      if (this.hasConfirmationTarget) this.confirmationTarget.value = event.detail.pin;
      if (this.hasFormTarget) this.formTarget.requestSubmit();
    }
  }

  failed(event) {
    this.stage = 1;
    if (this.hasPinTarget) this.pinTarget.value = "";
    if (this.hasConfirmationTarget) this.confirmationTarget.value = "";
    if (this.hasPinPadOutlet) this.pinPadOutlet.wrong();
    if (this.hasNoticeTarget) {
      this.noticeTarget.textContent = event.detail?.message || "";
      this.noticeTarget.classList.remove("hidden");
    }
    if (this.hasSubTarget) this.subTarget.textContent = this.initialPromptValue;
  }
}
